import {ILearningPathsCreateStoreState} from './ILearningPathsCreateStoreState';

export const learningPathsCreateInitialState: ILearningPathsCreateStoreState = {
  page: {
    loading: false,
  },
};
